import {Injectable} from "@angular/core";
import {TrackAddToWishlistDto} from "@app/core/tracking/domain/dtos/track-add-to-wishlist.dto";
import {TrackingService} from "@app/core/tracking/domain/repositories/tracking.service";

@Injectable({
    providedIn: 'root',
})
export class TrackAddToWishlistUseCase {
    constructor(
        private trackingService:TrackingService,
    ) {}

    execute(dto: Omit<TrackAddToWishlistDto,'currency'>) {
        this.trackingService.addToWishlist({
            currency: 'EUR',
            ...dto,
        })
    }
}
